<template>
  <div class="modal fade" id="replaceFile" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold" id="exampleModalLongTitle">Replace Turn Over Notes Excel</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label for="searchCrewFrom" class="font-weight-bold">File From (Crew):</label>
            <input type="text" class="form-control" id="searchCrewFrom" placeholder="Search Crew Here . ." value="Sample Crew Name">
          </div>
          <label for="inputGroupFile01" class="font-weight-bold">Replace File:</label>
          <div class="input-group mb-3">
            <div class="custom-file">
              <input type="file" class="custom-file-input" id="inputGroupFile01">
              <label class="custom-file-label" for="inputGroupFile01">Choose file</label>
            </div>
          </div>
          <div class="form-group">
            <label for="searchCrewTo" class="font-weight-bold">Assign To (Crew):</label>
            <input type="text" class="form-control" id="searchCrewTo" placeholder="Search Crew Here . ." value="Sample Crew Name">
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Close</button>
          <button type="button" class="btn btn-primary btn-sm">Save</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReplaceFile",
  /** mixins **/
  mixins: [],

  /** props **/
  props: {},

  /** data **/
  data() {
    return {};
  },

  /** methods**/
  methods: {},

  /**  computed  **/
  computed: {},

  /** mounted **/
  mounted() {
  },

  /** created **/
  created() {
  },

  /** watch
   searchText : {
			handler : 'fetchUserList',
			immediate : true,
		}
   **/
  watch: {},

  /** destroyed **/
  destroyed() {
  },
}
</script>

<style scoped lang="scss">

</style>